/* Cover My Plate · quantity price tiers (display only). The real discounts are Shopify automatic discounts; this file
   only shows them. To change a tier, edit SETS. To add or remove a product, edit PRODUCTS (product handle -> set name).
   Each tier: [pack quantity, discount (0.15 = 15% off), label]. Tapping a tier sets the quantity to the pack quantity. Used by cx-kinds.js (studio builders) and
   cmp-social-frame.js (social frame). A product that is not listed here shows no tiers. */
(function () {
  'use strict';
  var SETS = {
    keychain: [[1, 0, '1'], [5, 0.10, '5-pack'], [10, 0.15, '10-pack'], [25, 0.25, '25-pack'], [50, 0.35, '50-pack']],
    plate: [[1, 0, '1'], [2, 0.15, '2-pack'], [5, 0.20, '5-pack'], [10, 0.25, '10-pack'], [25, 0.35, '25-pack']]
  };
  var PRODUCTS = {
    'custom-keychain': 'keychain',
    'social-media-keychain': 'keychain',
    'custom-license-plate-frame-create-your-own': 'plate',
    'social-media-plate-frame': 'plate',
    'custom-vanity-plate-your-design': 'plate',
    'custom-mini-plate-12x3-your-design': 'plate',
    'custom-bicycle-vanity-license-plate-3x6': 'plate',
    'custom-motorcycle-vanity-license-plate-4x7': 'plate'
  };
  var MAX = 50;

  function get(handle) { var k = PRODUCTS[handle]; return (k && SETS[k]) || null; }
  function idx(t, q) { for (var k = t.length - 1; k > 0; k--) if (q >= t[k][0]) return k; return 0; }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function unit(base, d) { return Math.round(base * (1 - d)); }
  function label(t, j) { return t[j][2] || (t[j][0] === 1 ? '1' : t[j][0] + '-pack'); }

  function css() {
    if (document.getElementById('cxt-css')) return;
    var s = document.createElement('style');
    s.id = 'cxt-css';
    s.textContent =
      '.cxt{margin:14px 0 0}.cxt[hidden]{display:none!important}' +
      '.cxt__grid{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:6px}' +
      '.cxt__tier{display:grid;gap:3px;justify-items:center;padding:8px 2px;border:1.5px solid var(--cx-line,rgba(255,255,255,.16));border-radius:var(--cx-r,10px);background:var(--cx-bay,#151617);color:var(--cx-chalk,#f2f1ed);font:600 11px/1.2 var(--cx-font,inherit);cursor:pointer}' +
      '.cxt__tier b{font:700 14px/1 var(--cx-font,inherit)}.cxt__tier small{color:var(--cx-fog,#a3a6ab);font-size:11px}' +
      '.cxt__tier em{font-style:normal;color:var(--cx-lava,#cff516);font-size:11px;font-weight:700;min-height:1.2em}' +
      '.cxt__tier[aria-pressed=true]{border-color:var(--cx-lava,#cff516);background:var(--cx-bay-2,#1d1f20)}' +
      '.cxt__note{margin:8px 0 0;font-size:13px;color:var(--cx-fog,#a3a6ab)}' +
      '[data-cxt-each] s,[data-cxc-qtyeach] s{opacity:.6;margin-right:4px}' +
      '.cxt-qty{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:16px 0 0}' +
      '.cxt-qty__s{display:inline-flex;align-items:center;border:1.5px solid var(--cx-line,rgba(255,255,255,.16));border-radius:999px}' +
      '.cxt-qty__s button{width:40px;height:40px;border:0;background:none;color:inherit;font:600 20px/1 var(--cx-font,inherit);cursor:pointer}' +
      '.cxt-qty__s button:disabled{opacity:.35;cursor:default}.cxt-qty__s b{min-width:28px;text-align:center;font:700 16px/1 var(--cx-font,inherit)}' +
      '.cxt-qty small{display:block;color:var(--cx-fog,#a3a6ab);font-size:13px;margin-top:2px}' +
      '@media (max-width:420px){.cxt__grid{grid-template-columns:repeat(3,minmax(0,1fr))}}';
    document.head.appendChild(s);
  }

  /* tier table + note. labelClass: the page's own label style. onPick(qty) when a tier is tapped (quick-pick). */
  function mount(labelClass, onPick) {
    css();
    var w = document.createElement('div'), cur = null;
    w.className = 'cxt';
    w.hidden = true;
    w.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cxt-tier]');
      if (b) onPick(Math.max(1, Math.min(MAX, +b.getAttribute('data-cxt-tier') || 1)));
    });
    function build(t) {
      cur = t;
      w.innerHTML = '<p class="' + (labelClass || '') + '">Buy more, save more</p><div class="cxt__grid" role="group" aria-label="Price each by quantity">' +
        t.map(function (r, j) {
          return '<button type="button" class="cxt__tier" data-cxt-tier="' + r[0] + '" aria-pressed="false"><small>' + label(t, j) + '</small><b>—</b><em>' + (r[1] ? '−' + Math.round(100 * r[1]) + '%' : '') + '</em></button>';
        }).join('') + '</div><p class="cxt__note">Discount applies automatically at checkout.</p>';
    }
    /* t: tiers (null hides), q: quantity, base: full price each in cents. Returns {unit, d, total} or null. */
    function update(t, q, base) {
      if (!t) { w.hidden = true; return null; }
      if (t !== cur) build(t);
      w.hidden = false;
      var k = idx(t, q), d = t[k][1], ok = base != null && base > 0;
      Array.prototype.forEach.call(w.querySelectorAll('[data-cxt-tier]'), function (b, j) {
        b.setAttribute('aria-pressed', String(j === k));
        b.querySelector('b').textContent = ok ? money(unit(base, t[j][1])) : '—';
      });
      if (!ok) return null;
      var u = unit(base, d);
      return { unit: u, d: d, total: u * q };
    }
    return { el: w, update: update };
  }
  /* "$X each" with the full price struck through when a tier applies (HTML) */
  function eachHtml(base, r) {
    return r && r.d ? '<s>' + money(base) + '</s>' + money(r.unit) + ' each · ' + Math.round(100 * r.d) + '% off' : money(base) + ' each';
  }

  window.CXTiers = { sets: SETS, products: PRODUCTS, max: MAX, get: get, idx: idx, money: money, mount: mount, eachHtml: eachHtml };
})();
